import SeoTitle from '@/components/SeoTitle';
import PageJsonLd from './components/PageJsonLd';
import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import ClusterNavigation from './components/ClusterNavigation';
import WhatIsLeadership from './components/WhatIsLeadership';
import SpecialistToLeader from './components/SpecialistToLeader';
import LeadershipSkills from './components/LeadershipSkills';
import NoMicromanagement from './components/NoMicromanagement';
import LeadershipMotivation from './components/LeadershipMotivation';
import DifficultSituations from './components/DifficultSituations';
import WhenNeeded from './components/WhenNeeded';
import TargetAudience from './components/TargetAudience';
import FormatsSection from './components/FormatsSection';
import ProcessSection from './components/ProcessSection';
import WhyProgramsWork from './components/WhyProgramsWork';
import CompanyResults from './components/CompanyResults';
import AboutTrainer from './components/AboutTrainer';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import ReadNextSection from './components/ReadNextSection';
import Footer from '@/components/feature/Footer';

const navLinks = [
  { label: 'Навыки', target: 'skills' },
  { label: 'Программа', target: 'process' },
  { label: 'Результаты', target: 'results' },
  { label: 'FAQ', target: 'faq' },
];

export default function LeadershipTrainingPage() {
  return (
    <>
      
      <SeoTitle title="Тренинг по лидерству | Business Training" />
      <PageJsonLd />

      <div className="min-h-screen bg-white font-['Inter']">
        <Navbar
          links={navLinks}
          ctaLabel="Заказать тренинг"
          ctaTarget="contact"
        />
        <HeroSection />
        <ClusterNavigation />
        <WhatIsLeadership />
        <SpecialistToLeader />

        <div id="skills">
          <LeadershipSkills />
        </div>

        <NoMicromanagement />
        <LeadershipMotivation />
        <DifficultSituations />
        <WhenNeeded />
        <TargetAudience />
        <FormatsSection />

        <div id="process">
          <ProcessSection />
        </div>

        <WhyProgramsWork />

        <div id="results">
          <CompanyResults />
        </div>

        <AboutTrainer />
        <FAQSection />
        <CTASection />
        <ReadNextSection />
        <Footer />
      </div>
    </>
  );
}